import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-dark-950">
      <Header />
      
      {/* Hero Section */}
      <section className="relative section-dark py-32 lg:py-40 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-purple-600/10 to-transparent"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(168, 85, 247, 0.1) 0%, transparent 50%)'
        }}></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="mb-6">
              <span className="text-sm font-medium text-blue-400 tracking-wider uppercase">Beyond Data, Into Fandom</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
              <span className="gradient-text">간편한 온라인 증명서</span>
              <br />
              <span className="text-white">발급 플랫폼</span>
            </h1>
            <p className="text-xl text-gray-400 mb-10 leading-relaxed max-w-3xl mx-auto">
              엑셀 업로드만으로 수료증과 자격증을 일괄 발급하고, 학습자는 언제든지 
              안전하게 증명서를 조회하고 출력할 수 있습니다.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/register">
                <button className="btn-gradient text-lg px-8 py-4 whitespace-nowrap cursor-pointer">
                  <i className="ri-rocket-line mr-2"></i>
                  무료로 시작하기
                </button>
              </Link>
              <Link to="/demo">
                <button className="glass-card-light text-white px-8 py-4 rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
                  <i className="ri-play-circle-line mr-2"></i>
                  데모 체험하기
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 section-darker">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              <span className="text-white">감에 의존한 마케팅,</span>
              <br />
              <span className="gradient-text">한계는 분명합니다</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            <div className="glass-card p-8 card-hover">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-upload-cloud-2-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">간편한 엑셀 업로드</h3>
                  <p className="text-gray-400 leading-relaxed">
                    정해진 양식의 엑셀 파일만 업로드하면 수백 명의 증명서를 
                    한 번에 발급할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>

            <div className="glass-card p-8 card-hover">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">피상 지표 중심 선정</h3>
                  <p className="text-gray-400 leading-relaxed">
                    실제 전환과 무관한 크리에이터 기용으로 효율 하락 및 예산 낭비로 이어집니다.
                  </p>
                </div>
              </div>
            </div>

            <div className="glass-card p-8 card-hover">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">광고주·에이전시 의존적 운영</h3>
                  <p className="text-gray-400 leading-relaxed">
                    독립적 판단 어려워지고 내부 기준 부재로 의사결정이 지연됩니다.
                  </p>
                </div>
              </div>
            </div>

            <div className="glass-card p-8 card-hover">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-database-2-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">데이터 불투명성</h3>
                  <p className="text-gray-400 leading-relaxed">
                    데이터 출처·속성 미표기로 크리에이터 신뢰도 검증에 한계가 있습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 section-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              <span className="gradient-text font-logo">CEIS</span>
              <span className="text-white">는</span>
              <br />
              <span className="text-white">감이 아닌 </span>
              <span className="gradient-text">데이터로 판단합니다</span>
            </h2>
            <p className="text-xl text-gray-400 mt-6 max-w-3xl mx-auto">
              댓글러의 영향력과 댓글 내용을 함께 분석해, 팬덤을 정밀하게 측정합니다.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
            <div className="glass-card p-10">
              <div className="mb-6">
                <span className="text-sm font-medium text-gray-400 uppercase tracking-wider">기존 플랫폼</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">피상지표</h3>
              <p className="text-gray-400 mb-6">
                팔로워, 좋아요, ER 등 단순 피상 지표만을 사용
              </p>
              <div className="bg-dark-900/50 rounded-xl p-6 mb-6">
                <img 
                  src="https://byth-beta.imweb.me/upload/S20250902bde8b953e5152/498cb8156f154.png" 
                  alt="기존 방식"
                  className="w-full h-auto"
                />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">단순 계산</h3>
              <p className="text-gray-400 mb-6">
                숫자 데이터를 합산한 단순 계산법 사용
              </p>
              <div className="bg-dark-900/50 rounded-xl p-6">
                <img 
                  src="https://byth-beta.imweb.me/upload/S20250902bde8b953e5152/1fc49c3784fdd.png" 
                  alt="단순 계산"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <div className="glass-card-light p-10 border-2 border-blue-500/30">
              <div className="mb-6">
                <span className="text-sm font-medium gradient-text uppercase tracking-wider font-logo">CEIS</span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">본질지표</h3>
              <p className="text-gray-400 mb-6">
                댓글러의 영향력, 댓글 품질 등 본질에 치중된 지표 사용
              </p>
              <div className="bg-dark-900/50 rounded-xl p-6 mb-6">
                <img 
                  src="https://byth-beta.imweb.me/upload/S20250902bde8b953e5152/87217687ef6c1.png" 
                  alt="본질 지표"
                  className="w-full h-auto"
                />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">정량·정성 AI 분석지표</h3>
              <p className="text-gray-400 mb-6">
                정량·정성을 반영한 데이터를 AI가 분석
              </p>
              <div className="bg-dark-900/50 rounded-xl p-6">
                <img 
                  src="https://byth-beta.imweb.me/upload/S20250902bde8b953e5152/3f8522d40ca11.png" 
                  alt="AI 분석"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Score Section */}
      <section className="py-20 section-darker">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              <span className="text-white">마케팅에 필요한</span>
              <br />
              <span className="gradient-text">핵심 스코어</span>
              <span className="text-white">를 확인하세요</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            <div className="glass-card p-8 card-hover">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">팬덤 스코어</h3>
              <p className="text-gray-400 leading-relaxed">
                댓글러 영향력과 댓글 품질을 분석해 팬덤 성향을 수치화
              </p>
            </div>

            <div className="glass-card p-8 card-hover">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-share-forward-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">확산 스코어</h3>
              <p className="text-gray-400 leading-relaxed">
                콘텐츠 확산 가능성 바이럴 파워 측정해 지속 영향력 평가
              </p>
            </div>

            <div className="glass-card p-8 card-hover">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-exchange-dollar-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">전환 스코어</h3>
              <p className="text-gray-400 leading-relaxed">
                일반·광고 게시물의 반응 차이를 비교해 전환 가능성 측정
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Advanced Features */}
      <section className="py-20 section-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              <span className="gradient-text font-logo">CEIS</span>
              <span className="text-white">는 팬덤의 분석을 넘어</span>
              <br />
              <span className="gradient-text">클러스터/금액 기반 분석을 수행합니다</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="glass-card p-8">
              <div className="mb-4">
                <span className="text-xs font-medium text-blue-400 bg-blue-500/10 px-3 py-1 rounded-full">
                  2025년 12월 출시
                </span>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-message-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">댓글 기반 팬덤 분석</h3>
              <p className="text-gray-400 leading-relaxed">
                댓글러의 활동성과 영향력을 프로파일링하고 댓글 품질을 분석해 팬덤 반응을 수치화합니다.
              </p>
            </div>

            <div className="glass-card p-8">
              <div className="mb-4">
                <span className="text-xs font-medium text-purple-400 bg-purple-500/10 px-3 py-1 rounded-full">
                  Coming soon
                </span>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-group-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">클러스터 기반 캠페인 설계</h3>
              <p className="text-gray-400 leading-relaxed">
                구매자 중심 세분화로 캠페인을 설계하고, 중복 도달 관리와 크리에이터 교체·제외를 지원합니다.
              </p>
            </div>

            <div className="glass-card p-8">
              <div className="mb-4">
                <span className="text-xs font-medium text-green-400 bg-green-500/10 px-3 py-1 rounded-full">
                  Coming soon
                </span>
              </div>
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">금액 기반 캠페인 성과 예측</h3>
              <p className="text-gray-400 leading-relaxed">
                좋아요·댓글·전환을 예산 기준으로 환산해 전 단계 ROI 예측·설계, 수익성 중심 의사결정을 돕습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 section-darker relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 via-purple-600/20 to-transparent"></div>
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            이제 단순한 표면 지표가 아닌
            <br />
            <span className="gradient-text">본질 데이터를 활용할 때!</span>
          </h2>
          <p className="text-xl text-gray-400 mb-10">
            <span className="font-logo gradient-text">CEIS</span>에서 전환 가능성이 높은 크리에이터를 찾아보세요
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register">
              <button className="btn-gradient text-lg px-8 py-4 whitespace-nowrap cursor-pointer">
                <i className="ri-rocket-line mr-2"></i>
                무료로 시작하기
              </button>
            </Link>
            <Link to="/contact">
              <button className="glass-card-light text-white px-8 py-4 rounded-full hover:bg-white/20 transition-all text-lg whitespace-nowrap cursor-pointer">
                <i className="ri-customer-service-line mr-2"></i>
                서비스 문의
              </button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
